module.exports = __webpack_public_path__ + "static/media/maher.1b378e67.jpg";